import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=434b80f1&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=434b80f1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434b80f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('434b80f1')) {
      api.createRecord('434b80f1', component.options)
    } else {
      api.reload('434b80f1', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=434b80f1&scoped=true", function () {
      api.rerender('434b80f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tutorial/edit.vue"
export default component.exports